import { useEffect, useState } from "react";
import { HOME } from "@/constants/testIds";
import { Lightbox } from "@/components/Lightbox";
import { api, money, imgUrl } from "@/lib/api";

// Products featured in the gallery, in display order. Names, prices and photos come from the shop catalog.
const SLUGS = [
  "ruff-dawg-flying-fish", "ruff-dawg-big-dawg-barbell", "nylabone-power-chew-wishbone",
  "ruff-dawg-minnow", "busy-buddy-tug-a-jug", "ruff-dawg-twig",
  "nylabone-puppy-teething-rings", "nylabone-nutri-dent-fresh-breath-chews-mini-78ct", "coastal-rascals-knot-rope-tug",
];

const useLiveProducts = () => {
  const [photos, setPhotos] = useState([]);
  useEffect(() => {
    api.get("/products").then(({ data }) => {
      const bySlug = Object.fromEntries(data.map((p) => [p.slug, p]));
      setPhotos(SLUGS.filter((s) => bySlug[s]).map((s) => {
        const p = bySlug[s];
        return { slug: s, name: p.name, price: money(p.price), src: imgUrl(p.image), buyUrl: `/product/${s}` };
      }));
    }).catch(() => {});
  }, []);
  return photos;
};

export const Gallery = () => {
  const photos = useLiveProducts();
  const [openSlug, setOpenSlug] = useState(() => new URLSearchParams(window.location.search).get("product"));
  const open = photos.findIndex((p) => p.slug === openSlug);
  const close = () => {
    setOpenSlug(null);
    window.history.replaceState(null, "", window.location.pathname);
  };
  return (
  <section data-testid={HOME.gallery} className="max-w-7xl mx-auto px-6 lg:px-10 mt-24">
    <h2 className="font-heading text-base md:text-lg font-semibold uppercase tracking-[0.2em] text-[#4E7B68]">From our shelves</h2>
    <p className="font-heading mt-4 text-3xl sm:text-4xl font-extrabold tracking-tight">Tough toys and chews, Kiddee-approved.</p>
    <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4">
      {photos.map(({ src, name, slug }, i) => (
        <button
          key={slug}
          onClick={() => setOpenSlug(slug)}
          aria-label={`View ${name}`}
          className={`overflow-hidden rounded-3xl bg-[#F0EBE1] fade-up cursor-zoom-in ${i === 0 ? "col-span-2 row-span-2" : ""}`}
          style={{ animationDelay: `${i * 60}ms` }}
        >
          <img
            src={src}
            alt={name}
            loading="lazy"
            data-testid={HOME.galleryPhoto(i)}
            className="w-full h-full aspect-square object-cover hover:scale-105 transition-transform duration-500"
          />
        </button>
      ))}
    </div>
    {open >= 0 && <Lightbox photos={photos} index={open} onChange={(i) => setOpenSlug(photos[i].slug)} onClose={close} />}
  </section>
  );
};
